import { styled } from '@linaria/react';

export const Container = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	gap: var(--gap-x5);
`;

export const TagsGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;
	align-items: flex-start;
	align-self: stretch;
	gap: var(--gap-x2);
`;

export const LinkElement = styled.a`
	display: flex;
	width: fit-content;
	height: 32px;
	align-items: center;
	justify-content: center;
	padding: 0 8px;
	border: 1px solid var(--color-white-m, rgba(255, 255, 255, 0.2));
	border-radius: var(--radius-xl);
	backdrop-filter: blur(12px);

	&:hover:not(.disabled, :focus, .selected) {
		border-color: transparent;
		background-color: var(--color-white-xs);
	}
`;
